import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { StaticDictionaryItem } from 'src/app/shared/model/StaticDictionaryItem';
import { StaticDictionaryService } from 'src/app/shared/services/static-dictionary.service';
import { ControlSettings } from '../../ControlSettings';

@Component({
  selector: 'app-static-dictionary-multiselect-ctrl',
  templateUrl: './static-dictionary-multiselect.component.html',
  styleUrls: ['./static-dictionary-multiselect.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: StaticDictionaryMultiselectComponent,
    multi: true
  }]
})
export class StaticDictionaryMultiselectComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer, private staticDictionary: StaticDictionaryService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false};

  @Input() staticDictionaryName: string;
  @Input() textField  = 'value';
  @Input() valueField  = 'id';
  @Input() orderById : boolean;
  @Input() allowedValuesLimitation : number[];
  @Input() addSelectAllButton  = false;

  @Output() valueChangeEvent = new EventEmitter<number>();
 
  valueList$: Observable<StaticDictionaryItem[]>;

  possibleValues: StaticDictionaryItem[] = [];

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

    this.valueList$ = this.staticDictionary.getStaticDictionary(this.staticDictionaryName);

    if(this.allowedValuesLimitation){
      this.valueList$ = this.valueList$.pipe(map(x => x.filter(r => this.allowedValuesLimitation.includes(r.id))) );
    }

    if(this.orderById){
      this.valueList$ = this.valueList$.pipe(map(x => x.sort(this.orderDictionaryItemsById)) );
    }

    this.valueList$ = this.valueList$.pipe( tap((x) => this.possibleValues = x));

  }

  orderDictionaryItemsById(a:StaticDictionaryItem,b:StaticDictionaryItem): number {
    return a.id - b.id;
 }

 selectAll(){
  this.control.setValue(this.possibleValues.map(x => x.id));
 }

  onChange(value: number) {
   
    // this.control.setValue(value);
    this.valueChangeEvent.emit(value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
